import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["search", "hidden", "options"]

  connect() {
    this.optionsMap = new Map()
    this.refreshOptionsMap()

    this.boundOnInput = this.onInput.bind(this)
    this.boundOnBlur = this.onBlur.bind(this)
    this.boundOnOptionsClick = this.onOptionsClick.bind(this)

    this.searchTarget.addEventListener("input", this.boundOnInput)
    this.searchTarget.addEventListener("blur", this.boundOnBlur)
    this.optionsTarget.addEventListener("click", this.boundOnOptionsClick)
  }

  disconnect() {
    if (this.boundOnInput) this.searchTarget.removeEventListener("input", this.boundOnInput)
    if (this.boundOnBlur) this.searchTarget.removeEventListener("blur", this.boundOnBlur)
    if (this.boundOnOptionsClick) this.optionsTarget.removeEventListener("click", this.boundOnOptionsClick)
  }

  refreshOptionsMap() {
    this.optionsMap.clear()

    this.optionsTarget.querySelectorAll("el-option").forEach((option) => {
      const label = option.getAttribute("value")
      const id = option.dataset.optionId

      if (label) this.optionsMap.set(label, id)
    })
  }

  onInput() {
    const inputValue = this.searchTarget.value

    if (inputValue === "") {
      this.hiddenTarget.value = ""
      return
    }

    if (this.optionsMap.has(inputValue)) {
      this.hiddenTarget.value = this.optionsMap.get(inputValue)
    }
  }

  onOptionsClick(event) {
    const option = event.target.closest("el-option")
    if (!option) return

    this.hiddenTarget.value = option.dataset.optionId || ""
  }

  onBlur() {
    window.setTimeout(() => {
      const inputValue = this.searchTarget.value

      if (inputValue && !this.optionsMap.has(inputValue)) {
        this.searchTarget.value = ""
        this.hiddenTarget.value = ""
      }
    }, 200)
  }
}
